import {fixedToDisplayUnit} from "../../util/unitutils";
import {CategoryType} from "../../api/Constants";

export const DisplayProfitWidget = ({item, props}) => {
    let unitCost;

    if ((item.category === CategoryType.Wholesale) && (item.bulkCost !== null) && (item.bulkCost !== undefined)) {
        unitCost = parseFloat(item.bulkCost);
    } else {
        const displayStartQuantity = fixedToDisplayUnit(item.startQuantity, item.unit);
        unitCost = item.cost / displayStartQuantity;
    }
    const displayQuantity = fixedToDisplayUnit(item.quantity, item.unit);
    const totalCost = displayQuantity * unitCost;

    if (item.linePrice === null || item.linePrice === undefined) {
        return `$ 0.00`
    }

    const profit = (item.linePrice - item.lineDiscount) - totalCost;

    let profitStyle = {}
    if (profit > 0) {
        profitStyle = {color: 'green'}
    } else if (profit < 0) {
        profitStyle = {color: 'red'}
    }

    return <div style={profitStyle}>$ {profit.toFixed(2)}</div>;
}